export default __webpack_public_path__ + "static/media/ocbc.9d7565ac.svg";